<template>
  <div id="news" class="news">
    <div class="news-banner">
      <img :src="fileUrl+banner.img" alt="">
      <div>{{banner.title}}</div> 
    </div>   

    <div class="news-content">
      <div class="news-content-title">
        <div class="news-content-title-title">
          <div>NewsCenter</div> 
          <div>新闻中心</div>
          
        </div>
        <div class="news-content-title-service">
          <div></div>
          <div>实现每一位客户的需求,提供全程智能化精准服务</div>
          <div></div>
        </div>
      </div>
      <div class="news-content-content">
        <div class="news-content-content-item" v-for="(item,index) in list" :key="index" @click="goDetail(item)">
          <div>
            <div>{{item.day}}</div>
            <div>{{item.year}}/{{item.month}}</div>
          </div>
          <div>
            <div>{{item.title}}</div>
            <div>{{item.description}}</div>
          </div>
        </div>
        <el-pagination
            layout="prev, pager, next"
            :page-size="pageNumber"
            @current-change="getNews"
            prev-text="上一页"
            next-text="下一页"
            :total="total">
          </el-pagination>
      </div>
    </div>
 </div>
</template>

<script>
import { mapState} from 'vuex'
import * as API from '../api/api'
export default {
   computed: {
    ...mapState({fileUrl:state => state.fileUrl})
  },
  data(){
    return{   
      banner:{},
      defaultTitle:'关注互联网，关注吉埃思',
      defaultImg:require('../assets/img/new_banner.png'),
      list:[],
      pageNumber:3,//一页多少条数据
      total:0, //一共有多少数据
    }
  },
  mounted(){
    this.getBanner()
    this.getNews(1)
  },
  methods:{
    // 获取轮播图
    getBanner(){
      let that=this
      API.getBanner(4).then(res=>{
        if (res&&res.data) {
          that.banner={
            title:res.data.title,
            img:res.data.imgs.length>0 ? res.data.imgs[0] : that.defaultImg
          }
        }else{
          that.banner={
            title:that.defaultTitle,
            img:that.defaultImg
          }
        }
      })
    },
    goDetail(item){
      if (item.url) {
        window.open(item.url)
      }else{
        this.$router.push({name:'newsdetail',params: { detail: item }})
      }
      
    },
    // 获取新闻列表
    getNews(page){
      // newsC.scrollIntoView()
      let that=this
      let params={
        ComponentType:3,
        page:page,
        take:this.pageNumber
      }
      API.getComponents(params).then(res=>{
        // console.log(res);
        if (res&&res.data) {
          that.total=res.data.total
          that.list=res.data.contents.map(item=>{
            let time=item.updateTime.split('T')[0].split('-')
            item.day=time[2]
            item.month=time[1];
            item.year=time[0]
            return item
          })
        } else {
          that.$message({
            message: '获取数据失败',
            type: 'warning',
            duration:4000
          })
        }
        
      })
    },
  }
}
</script>
<style lang="scss">
  .el-pagination span{
    font-size:0.2rem !important; 
  }
  .el-pager li{
    font-size: 0.2rem !important;
  }
</style>
<style lang="scss" scoped>
  .news{
    padding-bottom: 1rem;
    &-banner{
      width: 100%;
      height: 4.4rem;
      position: relative;
      >img{
        width: 100%;
        height: 100%;
      }
     >div{
        position: absolute;
        left: 0;
        right: 0;
        top:2.4rem;
        margin: auto;
        font-size: 0.38rem;
        color: #AEB8BF;
        text-align: center;
      }
    }
    .news-content{
      width: 100%;
      padding-bottom: 1rem;
      &-title{
        &-title{
          margin-top: 0.6rem;        
          position: relative;
          text-align: center;
          >div:nth-child(1){
            position: relative;
            color: #E4EBFE;
            font-size: 0.8rem;
          }
          >div:nth-child(2){
            position: absolute;
            top: 0.4rem;
            font-size: 0.38rem;
            font-weight: 350;
            left: 0;
            right: 0;
            color: #555;
          }
        }
        &-service{
          margin:0.3rem auto;
          font-size: 0.24rem;
          color: #555;
          display: flex;
          align-items: center;
          justify-content: center;
          >div:nth-child(1) , >div:nth-child(3){
            width: 3rem;
            height:1px;
            background: #BFBFBF;
          }
          >div:nth-child(2){
            margin:0 0.3rem;
          }
        }
      }
      &-content{
        margin: auto;
        &-item{
          width: 70%;
          margin: 1rem auto;
          display: flex;
          cursor: pointer;
          >div:nth-child(1){
            width: 1.6rem;
            height: 1.6rem;
            border-radius: 0.2rem;
            background: #eee;
            color: #555;
            text-align: center;
            >div:nth-child(1){            
              font-size: 0.6rem;
              margin-top: 0.15rem;
            }
            >div:nth-child(2){
              font-size: 0.3rem;
            }
          }
          >div:nth-child(2){
            margin-left: 0.3rem;
            width: calc(100% - 2rem);
            >div:nth-child(1){
              color: #555;
              font-size: 0.24rem;
              margin-top: 0.1rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            >div:nth-child(2){
              color: #333;
              font-size: 0.2rem;
              margin-top: 0.3rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              line-clamp: 4;
              -webkit-box-orient: vertical;
            }
          }
        }
        .el-pager li , .el-pagination span{
          font-size: 0.24rem !important;
        }
      }
      .el-pagination {
        margin: auto;
        text-align: center;
      }
      
    }    
  }
</style>